/*  ========================================================================
    # Scripts - Cookiebot Toggle
    ========================================================================  */

/**
 * Script that triggers the Cookiebot overlay
 */

const CookiebotToggle = {
  cfg: {
    cookiebotToogles: document.querySelectorAll('[data-cookiebot-trigger]')
  },

  /**
   * Handle cookiebot toggle click
   */
  handleCookiebotToggles() {
    if (this.cfg.cookiebotToogles.length > 0) {
      this.cfg.cookiebotToogles.forEach(toggle => {
        toggle.addEventListener('click', e => {
          if (Cookiebot) {
            Cookiebot.show();
          }
        });
      });
    }
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.cookiebotToogles) {
      this.handleCookiebotToggles();
    }
  }
};

export default CookiebotToggle;
